import React from "react";

type PropsType = {
  theme?: "default" | "secondary" | "dark" | "transparent" | "red" | "transparent-white-home";
  size?: "default" | "big" | "small" | "medium";
  title: string;
  onClick: () => void;
  border?: boolean;
  leftIcon?: React.ReactNode;
  buttonClasses?: string;
  textClasses?: string;
  disabled?: boolean;
};

export default function Button({
  theme = "default",
  size = "default",
  title,
  onClick,
  border = true,
  leftIcon,
  buttonClasses,
  textClasses,
  disabled,
}: PropsType) {
  let borderClasses = "";
  let themeClasses = "bg-white text-black";
  let sizeClasses = "text-[16px]";
  let paddingClasses = "px-[38px] py-[15px]";

  if (border) {
    borderClasses = "border-[1px] border-[#5C5C5C]";
  }

  if (theme === "dark") {
    themeClasses = "bg-black text-white";
  }
  if (theme === "transparent") {
    themeClasses = "bg-transparent text-black";
  }
  if (theme === "transparent-white-home") {
    themeClasses = "bg-transparent text-white";
    borderClasses = "border-[1px] border-[#FFFFFF]";
  }
  if (theme === "red") {
    themeClasses = "bg-[#EC0202] text-white";
    borderClasses = "border-[1px] border-[#EC0202]";
  }
  if (theme === "secondary") {
    themeClasses = "bg-theme-grey-1 text-black";
    borderClasses = "";
  }

  if (size === "medium") {
    sizeClasses = "text-[12px]";
    paddingClasses = "px-[24px] py-[13px]";
  }

  return (
    <button
      className={`flex flex-row items-center gap-2 rounded-[4px] ${themeClasses} ${paddingClasses} transition hover:opacity-90 ${borderClasses} ${buttonClasses} disabled:opacity-50`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {leftIcon}
      <span className={`w-full font-medium ${sizeClasses} leading-none ${textClasses}`}>
        {title}
      </span>
    </button>
  );
}
